"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _HeaderCell = _interopRequireDefault(require("./HeaderCell"));

var _types = require("../utils/types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable jsx-a11y/click-events-have-key-events,jsx-a11y/interactive-supports-focus */
function Header(props) {
  var columns = props.columns,
      sorting = props.sorting,
      filtering = props.filtering,
      changeColumns = props.changeColumns,
      changeSorting = props.changeSorting,
      headerControls = props.headerControls,
      changeFiltering = props.changeFiltering;
  return /*#__PURE__*/_react.default.createElement("thead", null, /*#__PURE__*/_react.default.createElement("tr", {
    role: "row"
  }, columns.map(function (column) {
    return /*#__PURE__*/_react.default.createElement(_HeaderCell.default, {
      column: column,
      columns: columns,
      sorting: sorting,
      filtering: filtering,
      changeColumns: changeColumns,
      changeSorting: changeSorting,
      headerControls: headerControls,
      changeFiltering: changeFiltering
    });
  })));
}

Header.propTypes = {
  columns: _propTypes.default.arrayOf(_propTypes.default.shape({
    key: _propTypes.default.string,
    title: _propTypes.default.string,
    width: _propTypes.default.oneOf(_propTypes.default.string, _propTypes.default.number),
    minWidth: _propTypes.default.oneOf(_propTypes.default.string, _propTypes.default.number),
    hidden: _propTypes.default.bool,
    sortable: _propTypes.default.bool,
    className: _propTypes.default.string
  })),
  sorting: _types.sortState,
  filtering: _types.filteringState,
  changeColumns: _propTypes.default.func,
  changeSorting: _propTypes.default.func,
  changeFiltering: _propTypes.default.func,
  headerControls: _propTypes.default.shape({
    selectControlsLabel: _propTypes.default.shape({
      selectAll: _propTypes.default.string,
      reset: _propTypes.default.string
    }),
    sortByLabel: _propTypes.default.string
  }).isRequired
};
Header.defaultProps = {
  columns: [],
  sorting: null,
  filtering: null,
  changeColumns: function changeColumns() {},
  changeSorting: function changeSorting() {},
  changeFiltering: function changeFiltering() {}
};
var _default = Header;
exports.default = _default;